// USER
export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST"; 
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS"; 
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";

export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST"; 
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS"; 
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL";
export const USER_REGISTER_RESET = "USER_REGISTER_RESET";

export const USER_LOGOUT = "USER_LOGOUT";

export const USER_LOADED_REQUEST = "USER_LOADED_REQUEST"; 
export const USER_LOADED_SUCCESS = "USER_LOADED_SUCCESS"; 
export const USER_LOADED_FAIL = "USER_LOADED_FAIL";

export const USER_UPDATE_PROFILE_REQUEST = "USER_UPDATE_PROFILE_REQUEST";
export const USER_UPDATE_PROFILE_SUCCESS = "USER_UPDATE_PROFILE_SUCCESS";
export const USER_UPDATE_PROFILE_FAIL = "USER_UPDATE_PROFILE_FAIL";
export const USER_UPDATE_PROFILE_RESET = "USER_UPDATE_PROFILE_RESET";





// ADMIN
export const USER_LIST_REQUEST = "USER_LIST_REQUEST";
export const USER_LIST_SUCCESS = "USER_LIST_SUCCESS";
export const USER_LIST_FAIL = "USER_LIST_FAIL";
export const USER_LIST_RESET = "USER_LIST_RESET";

export const MAKER_LIST_REQUEST = "MAKER_LIST_REQUEST";
export const MAKER_LIST_SUCCESS = "MAKER_LIST_SUCCESS";
export const MAKER_LIST_FAIL = "MAKER_LIST_FAIL";
export const MAKER_LIST_RESET = "MAKER_LIST_RESET";

export const ADMIN_LIST_REQUEST = "ADMIN_LIST_REQUEST";
export const ADMIN_LIST_SUCCESS = "ADMIN_LIST_SUCCESS";
export const ADMIN_LIST_FAIL = "ADMIN_LIST_FAIL";
export const ADMIN_LIST_RESET = "ADMIN_LIST_RESET";

export const SINGLE_USER_DETAILS_REQUEST = "SINGLE_USER_DETAILS_REQUEST";
export const SINGLE_USER_DETAILS_SUCCESS = "SINGLE_USER_DETAILS_SUCCESS";
export const SINGLE_USER_DETAILS_FAIL = "SINGLE_USER_DETAILS_FAIL";

export const SINGLE_USER_UPDATE_REQUEST = "SINGLE_USER_UPDATE_REQUEST";
export const SINGLE_USER_UPDATE_SUCCESS = "SINGLE_USER_UPDATE_SUCCESS";
export const SINGLE_USER_UPDATE_FAIL = "SINGLE_USER_UPDATE_FAIL";
export const SINGLE_USER_UPDATE_RESET = "SINGLE_USER_UPDATE_RESET";

export const SINGLE_USER_DELETE_REQUEST = "SINGLE_USER_DELETE_REQUEST";
export const SINGLE_USER_DELETE_SUCCESS = "SINGLE_USER_DELETE_SUCCESS";
export const SINGLE_USER_DELETE_FAIL = "SINGLE_USER_DELETE_FAIL";


// REPORTS
export const USER_REPORT_REQUEST = "USER_REPORT_REQUEST";
export const USER_REPORT_SUCCESS = "USER_REPORT_SUCCESS";
export const USER_REPORT_FAIL = "USER_REPORT_FAIL";

export const USER_REPORT_LIST_REQUEST = "USER_REPORT_LIST_REQUEST";
export const USER_REPORT_LIST_SUCCESS = "USER_REPORT_LIST_SUCCESS";
export const USER_REPORT_LIST_FAIL = "USER_REPORT_LIST_FAIL";
export const USER_REPORT_LIST_RESET = "USER_REPORT_LIST_RESET";


export const USER_SINGLE_REPORT_REQUEST = "USER_SINGLE_REPORT_REQUEST";
export const USER_SINGLE_REPORT_SUCCESS = "USER_SINGLE_REPORT_SUCCESS";
export const USER_SINGLE_REPORT_FAIL = "USER_SINGLE_REPORT_FAIL";


export const USER_REPORT_DELETE_REQUEST = "USER_REPORT_DELETE_REQUEST";
export const USER_REPORT_DELETE_SUCCESS = "USER_REPORT_DELETE_SUCCESS";
export const USER_REPORT_DELETE_FAIL = "USER_REPORT_DELETE_FAIL";

